module.exports = __webpack_public_path__ + "static/media/branding-img10.117a8b7b.jpg";